export default __webpack_public_path__ + "static/Anton-Regular-db746a1872bfcd092bf879e4341f5004.ttf";